import { Link } from '@tanstack/react-router';
import { formatPublishedAt } from '../../../lib/format-date';
import type { ArticleCardData } from './ArticleCard';
import { SmartImage } from '../../../components/media/SmartImage';

function PostBlock({ title, items }: { title: string; items: ArticleCardData[] }) {
  if (items.length === 0) return null;
  return (
    <div className="post-entertainment">
      <div className="section-title">
        <h3 className="title">{title}</h3>
      </div>
      <div className="row">
        {items.map((item) => (
          <div className="col-lg-4 col-md-4" key={item.id}>
            <div className="trending-news-item mb-30">
              <div className="trending-news-thumb">
                <SmartImage media={item.coverMedia} alt={item.title} />
              </div>
              <div className="trending-news-content">
                <div className="post-meta">
                  {item.category && (
                    <div className="meta-categories">{item.category.name}</div>
                  )}
                  <div className="meta-date">
                    <span>{formatPublishedAt(item.publishedAt)}</span>
                  </div>
                </div>
                <h3 className="title">
                  <Link to="/articles/$slug" params={{ slug: item.slug }}>
                    {item.title}
                  </Link>
                </h3>
                <p className="text">
                  {(item.excerpt ?? item.contentText ?? '').slice(0, 100)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AllPostSection({
  politics,
  sports,
  economy,
}: {
  politics: ArticleCardData[];
  sports: ArticleCardData[];
  economy: ArticleCardData[];
}) {
  if (politics.length === 0 && sports.length === 0 && economy.length === 0) return null;
  return (
    <section className="all-post-area mt-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <PostBlock title="سياسية" items={politics} />
            <div className="sports-news-area">
              <PostBlock title="رياضية" items={sports} />
            </div>
            <div className="economy-news-area">
              <PostBlock title="اقتصاد" items={economy} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
